module.exports = __webpack_public_path__ + "static/media/nip-rejected.8278f537.svg";